'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _reactBootstrap = require('react-bootstrap');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _dateFunctions = require('../../helpers/dateFunctions');

var _dateFunctions2 = _interopRequireDefault(_dateFunctions);

var _LabelledInputComponent = require('../../components/input/LabelledInputComponent');

var _LabelledInputComponent2 = _interopRequireDefault(_LabelledInputComponent);

var _SelectComponent = require('../../components/input/SelectComponent');

var _SelectComponent2 = _interopRequireDefault(_SelectComponent);

var _RadioGroupComponent = require('../../components/input/RadioGroupComponent');

var _RadioGroupComponent2 = _interopRequireDefault(_RadioGroupComponent);

var _DatePickerComponent = require('../../components/input/DatePickerComponent');

var _DatePickerComponent2 = _interopRequireDefault(_DatePickerComponent);

var _Quote = require('../../validators/tugo/Quote');

var _Quote2 = _interopRequireDefault(_Quote);

var _translate = require('../../language/translate');

var _InitialValues = require('../common/InitialValues');

var _InitialValues2 = _interopRequireDefault(_InitialValues);

var _commonFunctions = require('../../helpers/commonFunctions');

var _formConfiguration = require('../../transformers/common/formConfiguration');

var _formConfiguration2 = _interopRequireDefault(_formConfiguration);

var _application = require('../../transformers/tugo/application');

var _application2 = _interopRequireDefault(_application);

var _quote = require('../../transformers/tugo/quote');

var _quote2 = _interopRequireDefault(_quote);

var _CheckboxComponent = require('../../components/input/CheckboxComponent');

var _CheckboxComponent2 = _interopRequireDefault(_CheckboxComponent);

var _TugoMedicalQuestionnaire = require('../../components/common/TugoMedicalQuestionnaire');

var _TugoMedicalQuestionnaire2 = _interopRequireDefault(_TugoMedicalQuestionnaire);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var fields = [].concat(_toConsumableArray((0, _commonFunctions.getBaseFields)()), _toConsumableArray((0, _commonFunctions.getApplicantDetailFields)()), _toConsumableArray((0, _commonFunctions.getApplicantSportFields)()), _toConsumableArray((0, _commonFunctions.getApplicantMedicalquestions)()), ['applicant[].additional_data.pe_coverage', 'application.additional_data.sports_selected', 'application.additional_data.destination', 'application.additional_data.deductible', 'application.additional_data.policy_type', 'application.additional_data.travelling_through_the_us', 'application.additional_data.number_of_travel_days_in_the_us', 'application.additional_data.number_of_days_per_trip', 'application.additional_data.state', 'application.additional_data.home_province']);

/**
 * Renders the part of the form which generates a live quote.
 * @extends {Component}
 */

var GetQuoteComponent = function (_React$Component) {
  _inherits(GetQuoteComponent, _React$Component);

  function GetQuoteComponent(props) {
    _classCallCheck(this, GetQuoteComponent);

    var _this = _possibleConstructorReturn(this, (GetQuoteComponent.__proto__ || Object.getPrototypeOf(GetQuoteComponent)).call(this, props));

    _this.getSportText = function (value) {
      var found = _this.state.sportOptions.find(function (s) {
        return s.value === value;
      });
      return found ? found.text : value;
    };

    _this.handleSportChange = function (value) {
      _this.setState({ selectedSport: value });
    };

    _this.updateAllTravelersChecked = function (question, index) {
      var sportKey = question.key.split('.').pop();

      var allChecked = _this.props.fields.applicant.every(function (applicant) {
        return applicant.additional_data.sports_coverage[sportKey] && applicant.additional_data.sports_coverage[sportKey].value === 'true';
      });

      _this.setState(function (prev) {
        return {
          allTravelersChecked: _extends({}, prev.allTravelersChecked, _defineProperty({}, sportKey, allChecked))
        };
      });

      _this.saveSelectedToApplicants();
      _this.onChangeHook();
    };

    _this.shouldShowMQModal = function () {
      var applicants = _this.props.fields.applicant || [];
      var effDate = _this.props.fields.application.effective_date.value;

      if (!effDate) return false;

      return applicants.some(function (app) {
        var dobStr = app.dob.value;
        var firstName = app.first_name.value;
        var lastName = app.last_name.value;

        if (!dobStr || !firstName || !lastName) return false;

        var age = (0, _moment2.default)(effDate).diff(dobStr, 'years');

        return age >= 60;
      });
    };

    _this.showSportsButton = function () {
      var applicants = _this.props.fields.applicant || [];

      return applicants.some(function (app) {
        var firstName = app.first_name.value;
        var lastName = app.last_name.value;

        if (!firstName || !lastName) return false;

        return true;
      });
    };

    _this.onChangeHook = _this.onChangeHook.bind(_this);
    _this.isMultiTrip = _this.isMultiTrip.bind(_this);
    _this.getDefaultExpiryDate = _this.getDefaultExpiryDate.bind(_this);
    _this.shouldShowMQModal = _this.shouldShowMQModal.bind(_this);
    _this.getApplicantsWithMQ = _this.getApplicantsWithMQ.bind(_this);

    _this.state = {
      showNames: true,
      formFilled: false,
      showSaveQuote: true,
      showErrors: false,
      showMQModal: false,
      showSportsModal: false,
      showSportsDropdown: false,
      selectedSport: '',
      selectedSports: [],
      sportOptions: (0, _commonFunctions.sportOptions)(),
      showSportsDetailsAndCoverages: false,
      allTravelersChecked: {},
      sportsUptoPolicyLimit: [{
        title: 'Backcountry skiing/snowboarding',
        value: 'backcountry',
        content: 'Backcountry means an area that is not marked, not patrolled and/or not cleared for avalanche dangers, but where public access is permitted. Backcountry is also known as slackcountry, sidecountry and/or off-piste and does not include heli-skiing or cat skiing.'
      }, {
        title: 'Boxing',
        value: 'boxing',
        content: ''
      }, {
        title: 'Downhill freestyle skiing/snowboarding in organized competitions',
        value: 'downhill_skiing',
        content: 'Downhill freestyle skiing/snowboarding in organized competitions means any skiing/snowboarding competition with the following activities: aerial skiing/snowboarding, kite-skiing, mogul or cross competitions, half-pipes and/or slopestyle activities, rails, jumps and other terrain park features.'
      }, {
        title: 'Downhill mountain biking',
        value: 'downhill_mountain_biking',
        content: 'Downhill mountain biking means biking down mountain trails or rough mountain terrain (whether as part of a race or not) and often features jumps, drops, rock gardens or other obstacles. It often requires the use of mechanical lifts or elevators.'
      }, {
        title: 'Ice climbing',
        value: 'ice_climbing',
        content: 'Ice climbing means the act of climbing or rappelling from vertical or nearly vertical ice formations such ice falls, frozen waterfalls or cliffs or rock slabs that are covered with ice from flows of water freezing over. Ice climbing requires the use of specialized equipment including but not limited to ice axes, crampons or ice screws. Glacier hiking is not ice climbing. If the glacier hike is on a mountain, it is considered mountaineering up to a 6,000-metre elevation or mountaineering over a 6,000-metre elevation.'
      }, {
        title: 'Mixed martial arts',
        value: 'mixed_martial_arts',
        content: 'Mixed martial arts means a combat sport in which participants use fighting and grappling techniques from any combination of wrestling, boxing and martial arts. Mixed martial arts include ultimate fighting.'
      }, {
        title: 'Mountaineering up to a 6,000-metre elevation',
        value: 'mountaineering_6000',
        content: 'Mountaineering up to a 6,000-metre elevation means the act of climbing or descending a mountain to or from an elevation of 6,000 metres or less (measured from sea level) while using specialized equipment including but not limited to pickaxes, ice axes, anchors, bolts, crampons, carabineers and lead or top rope anchoring equipment. Mountaineering includes ski mountaineering also known as ‘skimo’.<br>For the Sports & Activities Optional Coverage, if you are ice climbing and mountaineering up to a 6,000-metre elevation, you only need to select mountaineering up to a 6,000-metre elevation, and ice climbing will automatically be covered as well.<br>We recognise that ice climbing equipment may be used while mountaineering, so we don’t want you to have to pay an additional surcharge if you’re doing some ice climbing as part of your mountaineering. However, if you’re also planning to do ice climbing as a separate activity from mountaineering during your trip, you need to add ice climbing to the Sports & Activities Optional Coverage for coverage to apply. Please refer to the definition of ‘ice climbing’ for more details.'
      }, {
        title: 'Mountaineering over a 6,000-metre elevation',
        value: 'mountaineering_over_6000',
        content: 'Mountaineering over a 6,000-metre elevation means the act of climbing or descending a mountain to or from an elevation of over 6,000 metres (measured from sea level) while using specialized equipment including but not limited to pickaxes, ice axes, anchors, bolts, crampons, carabineers and lead or top rope anchoring equipment. Mountaineering includes ski mountaineering also known as ‘skimo’.<br><br>For the Sports & Activities Optional Coverage: <ul><li>If you are mountaineering both below and above 6,000 metres elevation, you only need to select mountaineering over a 6,000-metre elevation.</li><li>If you are ice climbing and mountaineering over 6,000 metres elevation, you do not need to select both activities. You only need to select mountaineering over a 6,000-metre elevation, and ice climbing will automatically be covered as well.</li></ul><br>We recognise that ice climbing equipment may be used while mountaineering, so we don’t want you to have to pay an additional surcharge if you’re doing some ice climbing as part of your mountaineering. However, if you’re also planning to do ice climbing as a separate activity from mountaineering during your trip, you need to add ice climbing to the Sports & Activities Optional Coverage for coverage to apply. Please refer to the definition of ‘ice climbing’ for more details.'
      }, {
        title: 'Rock climbing',
        value: 'rock_climbing',
        content: 'Rock climbing means the sport of climbing rock faces, especially with the aid of ropes and special equipment. Rock climbing includes the following activities: bouldering, traditional climbing, free soloing, top-rope, sports climbing, canyoning/canyoneering, but does not include climbing indoor or outdoor artificial rock climbing walls.'
      }, {
        title: 'Football (American or Canadian)',
        value: 'american_football',
        content: 'You can add football to the Sports & Activities Coverage if you are 21 years or over at the time of application and plan to participate, train, or practice on behalf of a registered team, league, association or club; or while competing in a registered tournament, competition or sporting event. If you are just casually playing football for fun, you don\'t need to purchase additional coverage.<br><br>If you are under 21 years, coverage is already available under the Emergency Medical Insurance plan without the purchase of this optional coverage.'
      }, {
        title: 'Ice hockey',
        value: 'ice_hockey',
        content: 'You can add ice hockey to the Sports & Activities Coverage if you are 21 years or over at the time of application and plan to participate, train, or practice on behalf of a registered team, league, association or club; or while competing in a registered tournament, competition or sporting event.<br><br>If you are under 21 years, coverage is already available under the Emergency Medical Insurance plan without the purchase of this optional coverage.'
      }, {
        title: 'Rugby',
        value: 'rugby',
        content: 'You can add rugby to the Sports & Activities Coverage if you are 21 years or over at the time of application and plan to participate, train or practice on behalf of a registered team, league, association or club; or while competing in a registered tournament, competition or sporting event. <br><br>If you are under 21 years, coverage is already available under the Emergency Medical Insurance plan without the purchase of this optional coverage. If you are just casually playing rugby for fun, you don\'t need to purchase additional coverage.'
      }],
      sportsUptoMax: [{
        title: 'BASE Jumping',
        value: 'base_jumping',
        content: ''
      }, {
        title: 'Hanging gliding/paragliding',
        value: 'hang_gliding',
        content: ''
      }, {
        title: 'High risk motorized speed activities',
        value: 'high_risk_motorized_speed',
        content: 'High risk motorized speed activities means: <br><br><ul><li>a) Motocross, dirt biking and/or motorcycling unless only riding as a mode of transportation; and/or,</li><li>b) Any motorized vehicle racing competitions, endurance events or timed activities, including but not limited to snowmobiling racing competitions or endurance events.</li></ul>If you are participating in a motorized vehicle activity, other than the ones specified under part a), and the activity is solely for leisure and not part of a timed activity or done for the purpose of training or practicing for any kind of racing competition or endurance event, this activity is not considered a high risk motorized speed activity and the Sports & Activities Optional Coverage is not required for coverage to apply.'
      }, {
        title: 'High risk snowmobiling and motorized snow biking',
        value: 'high_risk_snowmobiling',
        content: 'High risk snowmobiling  and motorized snow biking means snowmobiling (including highmarking) and/or motorized snow biking in unguided backcountry terrain.'
      }, {
        title: 'Parachuting/skydiving/tandem skydiving',
        value: 'parachuting',
        content: ''
      }, {
        title: 'Scuba diving or free diving over 40 metres',
        value: 'scuba_diving',
        content: ''
      }, {
        title: 'White water rafting – Class VI',
        value: 'white_water_sports',
        content: 'White water rafting – Class VI means rafting on extreme rapids or waterfalls deemed unnavigable according to safety authorities. Class VI white water rafting includes rafting on rapids with substantial levels of white water, large waves, hazardous rocks and/or drops with the potential to damage most rafting equipment.'
      }, {
        title: 'Wingsuit flying',
        value: 'wingsuit_flying',
        content: ''
      }],
      excludedActivitiesList1: ['Backcountry skiing/snowboarding', 'Downhill freestyle skiing/snowboarding in organized competitions', 'High risk snowmobiling and motorized snow biking', 'Ice climbing', 'Mountaineering over a 6,000-metre elevation', 'Mountaineering up to a 6,000-metre elevation', 'Rock climbing'],
      excludedActivitiesList2: ['Barrel racing', 'Bronc riding', 'Bull riding', 'Chariot racing', 'Chuck wagon racing', 'Harness racing', 'Rodeo bareback racing', 'Rodeo clowning', 'Rodeo team roping', 'Steer wrestling/chute dogging', 'Trick riding']
    };
    return _this;
  }

  _createClass(GetQuoteComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.formConfig = (0, _formConfiguration2.default)(this.props.formConfig)[0].fields;
      if (this.props.fields.application.additional_data.additional_applicants_number.value === '') {
        this.props.fields.application.additional_data.additional_applicants_number.onChange(_InitialValues2.default.additional_applicants_number);
      }
      if (this.props.fields.applicant.length === 0) {
        this.props.fields.applicant.addField();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.syncSelectedSportsState();
    }
  }, {
    key: 'onChangeHook',
    value: function onChangeHook() {
      (0, _commonFunctions.updateQuote)(this, _application2.default);
    }
  }, {
    key: 'getDefaultExpiryDate',
    value: function getDefaultExpiryDate() {
      var effDate = this.props.fields.application.effective_date.value;
      return effDate ? (0, _moment2.default)(effDate).add(364 + _dateFunctions2.default.getLeapYearDay(effDate, 364), 'days') : null;
    }
  }, {
    key: 'getAgeLimits',
    value: function getAgeLimits() {
      return {
        maxYears: 150,
        seniorYears: 60,
        seniorMaxCoverageDays: ['NT', 'PE', 'YT', 'QC'].includes(this.props.fields.application.additional_data.state.value) ? 181 : 211
      };
    }
  }, {
    key: 'getSportQuestions',
    value: function getSportQuestions() {
      var _this2 = this;

      return this.state.selectedSports.map(function (sport, index) {
        return {
          key: 'sports_coverage.' + sport,
          text: 'Who is participating in, training or practicing for ' + _this2.getSportText(sport) + '?',
          id: index,
          keyPath: 'additional_data.sports_coverage.' + sport
        };
      });
    }
  }, {
    key: 'getApplicantsWithMQ',
    value: function getApplicantsWithMQ() {
      var _this3 = this;

      return this.props.fields.applicant.filter(function (el) {
        return (0, _moment2.default)(_this3.props.fields.application.effective_date.value).diff((0, _moment2.default)(el.dob.value), 'years') >= 60;
      });
    }
  }, {
    key: 'isMultiTrip',
    value: function isMultiTrip() {
      return this.props.fields.application.additional_data.policy_type.value === 'multi-trip annual';
    }
  }, {
    key: 'disableExpiryDate',
    value: function disableExpiryDate() {
      return this.isMultiTrip();
    }
  }, {
    key: 'updateProp',
    value: function updateProp(propName, value) {
      this.props.dispatch((0, _reduxForm.change)('genericis', propName, value));
    }
  }, {
    key: 'showSportsModal',
    value: function showSportsModal() {
      this.setState({
        showSportsModal: true,
        showSportsDropdown: !this.state.selectedSports.length > 0
      });
    }
  }, {
    key: 'showMQModal',
    value: function showMQModal() {
      this.setState({ showMQModal: true });
    }
  }, {
    key: 'syncSelectedSportsState',
    value: function syncSelectedSportsState() {
      var _this4 = this;

      var _props = this.props,
          values = _props.values,
          savedQuote = _props.savedQuote;

      var applicants = values && values.applicant.length > 0 ? values.applicant : savedQuote && savedQuote.additional_data && savedQuote.additional_data.applicants || [];

      if (this.state.selectedSports && this.state.selectedSports.length > 0) {
        return;
      }

      var allSelectedSports = applicants.reduce(function (acc, applicant) {
        var sports = applicant.additional_data.sports || [];
        sports.forEach(function (sport) {
          var matched = _this4.state.sportOptions.find(function (opt) {
            return opt.text === sport;
          });
          if (matched) {
            acc.add((0, _translate.t)(matched.value));
          } else {
            acc.add((0, _translate.t)(sport));
          }
        });
        return acc;
      }, new Set());

      this.setState({ selectedSports: Array.from(allSelectedSports) });
    }
  }, {
    key: 'saveSelectedToApplicants',
    value: function saveSelectedToApplicants() {
      var _this5 = this;

      var applicantFields = this.props.fields.applicant || [];

      applicantFields.forEach(function (applicant, i) {
        var sportsCoverage = applicant.additional_data.sports_coverage || {};

        var currentlySelected = Object.keys(sportsCoverage).filter(function (sportKey) {
          var sportField = sportsCoverage[sportKey];
          return sportField && sportField.value === true;
        });

        var updateToText = currentlySelected.map(function (sportKey) {
          var matchedOption = _this5.state.sportOptions.find(function (opt) {
            return opt.value === sportKey;
          });
          return matchedOption ? (0, _translate.t)(matchedOption.text) : (0, _translate.t)(sportKey);
        });

        var sportsFieldPath = 'applicant[' + i + '].additional_data.sports';

        _this5.updateProp(sportsFieldPath, updateToText);
      });
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      this.setState({ showSportsModal: false, showMQModal: false });

      this.saveSelectedToApplicants();
      this.onChangeHook();
    }
  }, {
    key: 'toggleAllTravelers',
    value: function toggleAllTravelers(sportKey, isChecked) {
      var _this6 = this;

      var applicantFields = this.props.fields.applicant || [];
      applicantFields.forEach(function (applicant) {
        var sportField = applicant.additional_data.sports_coverage[sportKey];
        if (sportField && sportField.value !== isChecked) {
          sportField.onChange(isChecked);
        }
      });

      setTimeout(function () {
        _this6.saveSelectedToApplicants();
        _this6.onChangeHook();
      }, 0);
    }
  }, {
    key: 'isAllTravelersChecked',
    value: function isAllTravelersChecked(sportKey) {
      var applicantFields = this.props.fields.applicant || [];
      return applicantFields.every(function (applicant) {
        return applicant.additional_data.sports_coverage[sportKey] && applicant.additional_data.sports_coverage[sportKey].value === true;
      });
    }
  }, {
    key: 'updateSelectedSports',
    value: function updateSelectedSports(selected) {
      if (!this.state.selectedSports.includes(selected)) {
        var updatedSport = [].concat(_toConsumableArray(this.state.selectedSports), [selected]);
        this.setState(function (prevState) {
          return {
            selectedSports: updatedSport,
            selectedSport: '',
            showSportsDropdown: false
          };
        });

        var reduxSportsField = this.props.fields.application.additional_data.sports_selected;
        if (reduxSportsField && typeof reduxSportsField.onChange === 'function') {
          reduxSportsField.onChange(updatedSport);
        }
      }
    }
  }, {
    key: 'showAlertMessage',
    value: function showAlertMessage(type, message) {
      var buttonText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var onClick = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      var className = type === 'error' && 'disclaimer-alert';
      return _react2.default.createElement(
        _reactBootstrap.Alert,
        { className: 'ingle-form-quote quote-box div-center tugo-alert' },
        _react2.default.createElement(
          'table',
          null,
          _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                { className: className },
                (0, _translate.t)(message)
              )
            ),
            buttonText && onClick && _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                { className: 'text-center' },
                _react2.default.createElement(
                  _reactBootstrap.Button,
                  {
                    bsStyle: 'primary',
                    className: 'ingle-form-submit-button button',
                    onClick: onClick
                  },
                  (0, _translate.t)('Open Medical Questionnaire')
                )
              )
            )
          )
        )
      );
    }
  }, {
    key: 'toggleSportExpand',
    value: function toggleSportExpand(index) {
      var currentIndex = this.state.expandedIndex;
      this.setState({ expandedIndex: currentIndex === index ? null : index });
    }
  }, {
    key: 'showSportsDetailsAndCoverages',
    value: function showSportsDetailsAndCoverages() {
      var _this7 = this;

      return _react2.default.createElement(
        _reactBootstrap.Modal,
        { show: this.state.showSportsDetailsAndCoverages, bsSize: 'md', onHide: function onHide() {
            return _this7.setState({ showSportsDetailsAndCoverages: false });
          } },
        _react2.default.createElement(
          _reactBootstrap.Modal.Header,
          { closeButton: true },
          _react2.default.createElement(
            _reactBootstrap.Modal.Title,
            null,
            (0, _translate.t)('Sports & Activities Coverage')
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          _react2.default.createElement(
            'div',
            { className: 'sports-coverage-details' },
            _react2.default.createElement(
              'div',
              { className: 'section' },
              _react2.default.createElement(
                'p',
                null,
                (0, _translate.t)('When you buy the Sports & Activities Optional Coverage, you can add all the sports and activities that you would like to be covered for while you\'re away if you plan to participate, train or practice for any of them during your trip. See below for details on the sports & activities and the exclusion that may apply.')
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'p',
                null,
                (0, _translate.t)('If a sport or activity is not listed as an option in the Sports & Activities Coverage and is not listed as an exclusion, coverage is already available under the Emergency Medical Insurance plan without the purchase of this optional coverage.')
              ),
              _react2.default.createElement(
                'p',
                { className: 'info-box info-section' },
                (0, _translate.t)('If you are coaching, teaching or officiating as a referee or sports official for any of the sports or activities, you do not need to purchase the Sports &amp; Activities Optional Coverage for coverage to apply.')
              )
            ),
            this.renderCoverageLimitsSection(this.state.sportsUptoPolicyLimit, 'Sports & Activities Covered Up to the Policy Limit', 'If you add any of the sports or activities listed below, they will be covered up to the policy limit of the Emergency Medical Insurance plan.'),
            this.renderCoverageLimitsSection(this.state.sportsUptoMax, 'Sports & Activities Covered Up to a Maximum of $500,000.00', 'If you add any of the sports or activities listed below, they will be covered up to a combined maximum limit of $500,000.0.'),
            _react2.default.createElement(
              'div',
              { className: 'section' },
              _react2.default.createElement(
                'h5',
                null,
                (0, _translate.t)('Excluded Activities')
              ),
              _react2.default.createElement(
                'p',
                null,
                (0, _translate.t)('The following exclusions apply:')
              ),
              _react2.default.createElement(
                'p',
                null,
                (0, _translate.t)('Your participating, training or practicing in any areas that have been closed off to public access and/or can typically only be accessed by crossing a fenced, gated or roped-off area that has been marked as off limits according to recommendations of safety authorities in the area for the following activities:')
              ),
              _react2.default.createElement(
                'div',
                { className: 'excluded-table' },
                _react2.default.createElement(
                  'div',
                  { className: 'table-header' },
                  _react2.default.createElement(
                    'span',
                    null,
                    (0, _translate.t)('Activity')
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    (0, _translate.t)('Is it covered?')
                  )
                ),
                this.state.excludedActivitiesList1.map(function (activity, index) {
                  return _react2.default.createElement(
                    'div',
                    { key: index, className: 'table-row' },
                    _react2.default.createElement(
                      'span',
                      null,
                      activity
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'excluded-icon' },
                      '\u2718'
                    )
                  );
                }),
                _react2.default.createElement(
                  'p',
                  { className: 'sub-header' },
                  (0, _translate.t)('Your participating in, training or practicing for any of the following sports or activities:')
                ),
                this.state.excludedActivitiesList2.map(function (activity, index) {
                  return _react2.default.createElement(
                    'div',
                    { key: index, className: 'table-row' },
                    _react2.default.createElement(
                      'span',
                      null,
                      activity
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'excluded-icon' },
                      '\u2718'
                    )
                  );
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'section' },
              _react2.default.createElement(
                'h3',
                null,
                (0, _translate.t)('Sports & Activities Optional Coverage')
              ),
              this.showOptionalCoverageDetails(),
              _react2.default.createElement(
                'p',
                null,
                (0, _translate.t)('*Optional Coverage benefit limits for $10,000,000 are subject to the overall maximum limit of the Emergency Medical Insurance plan.')
              )
            )
          )
        )
      );
    }
  }, {
    key: 'showOptionalCoverageDetails',
    value: function showOptionalCoverageDetails() {
      var _this8 = this;

      return _react2.default.createElement(
        'div',
        { className: 'optional-coverage-summary' },
        this.state.selectedSports.map(function (sport, index) {
          var matchInPolicy = _this8.state.sportsUptoPolicyLimit.find(function (item) {
            return (0, _translate.t)(item.value) === sport;
          });
          var matchInMax = _this8.state.sportsUptoMax.find(function (item) {
            return (0, _translate.t)(item.value) === sport;
          });

          var coverage = matchInPolicy ? matchInPolicy.title + ' $10,000,000.00' : matchInMax ? matchInMax.title + ' $500,000.00' : '';

          return _react2.default.createElement(
            'p',
            { key: index },
            coverage
          );
        })
      );
    }
  }, {
    key: 'showApplicantSports',
    value: function showApplicantSports() {
      var _props2 = this.props,
          values = _props2.values,
          savedQuote = _props2.savedQuote;

      var applicants = values && values.applicant.length > 0 ? values.applicant : savedQuote && savedQuote.additional_data && savedQuote.additional_data.applicants || [];

      return applicants.some(function (applicant, i) {
        var sports = applicant.additional_data.sports || [];
        return sports && sports.length > 0;
      });
    }
  }, {
    key: 'renderCoverageLimitsSection',
    value: function renderCoverageLimitsSection(data, sectionTitle, sectionDescription) {
      var _this9 = this;

      return _react2.default.createElement(
        'div',
        { className: 'coverage-section' },
        _react2.default.createElement(
          'h5',
          { className: '' },
          sectionTitle
        ),
        _react2.default.createElement(
          'p',
          { className: 'section-description' },
          sectionDescription
        ),
        _react2.default.createElement(
          'div',
          { className: 'coverage-list' },
          data.map(function (item, i) {
            return _react2.default.createElement(
              'div',
              { className: 'coverage-item', key: i },
              _react2.default.createElement(
                'div',
                { className: 'coverage-header', onClick: item.content && _this9.toggleSportExpand.bind(_this9, i) },
                _react2.default.createElement(
                  'span',
                  null,
                  item.title
                ),
                item.content && (_this9.state.expandedIndex === i ? _react2.default.createElement(
                  'span',
                  null,
                  '\u25BC'
                ) : _react2.default.createElement(
                  'span',
                  null,
                  '\u25BA'
                ))
              ),
              _this9.state.expandedIndex === i && _react2.default.createElement('div', { className: 'coverage-content', dangerouslySetInnerHTML: { __html: item.content } })
            );
          })
        )
      );
    }
  }, {
    key: 'renderSportsSummary',
    value: function renderSportsSummary() {
      var _this10 = this;

      var _props3 = this.props,
          values = _props3.values,
          savedQuote = _props3.savedQuote;

      var applicants = values && values.applicant.length > 0 ? values.applicant : savedQuote && savedQuote.additional_data && savedQuote.additional_data.applicants || [];
      var hasSelectedSports = applicants.some(function (applicant) {
        return (applicant.additional_data.sports || []).length > 0;
      });

      if (!hasSelectedSports) return null;

      return _react2.default.createElement(
        'div',
        { className: 'sports-summary' },
        _react2.default.createElement(
          'div',
          { className: 'sports-summary__header' },
          _react2.default.createElement(
            'div',
            { className: 'sports-summary__col sports-summary__col--traveller' },
            'Traveller'
          ),
          _react2.default.createElement(
            'div',
            { className: 'sports-summary__col sports-summary__col--activities' },
            (0, _translate.t)('SPORTS & ACTIVITIES'),
            _react2.default.createElement(
              'span',
              { className: 'sports-summary__edit', onClick: this.showSportsModal.bind(this) },
              (0, _translate.t)('EDIT')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: ' sports-summary__edit', onClick: function onClick() {
                return _this10.setState({ showSportsDetailsAndCoverages: true });
              } },
            (0, _translate.t)('View Sports & Activities Coverages')
          )
        ),
        applicants.map(function (applicant, index) {
          var sports = applicant.additional_data.sports || [];
          if (sports.length === 0) return null;

          return _react2.default.createElement(
            'div',
            { key: index, className: 'sports-summary__row' },
            _react2.default.createElement(
              'div',
              { className: 'sports-summary__col sports-summary__col--traveller' },
              (applicant.first_name || '') + ' ' + (applicant.last_name || '')
            ),
            _react2.default.createElement(
              'div',
              { className: 'sports-summary__col sports-summary__col--activities' },
              sports.map(function (sport, idx) {
                return _react2.default.createElement(
                  'div',
                  { key: idx, className: 'sports-summary__sport' },
                  sport
                );
              })
            )
          );
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this11 = this;

      (0, _quote2.default)(this);

      var ageLimits = this.getAgeLimits();
      var dateRestrictions = _dateFunctions2.default.getDateLimits(this.props.values, ageLimits);

      return _react2.default.createElement(
        _reactBootstrap.Form,
        { horizontal: true, onSubmit: this.props.handleSubmit },
        (0, _commonFunctions.showErrorDiv)(this),
        (0, _commonFunctions.showPrimaryApplicantInfo)(this, dateRestrictions),
        _react2.default.createElement(_LabelledInputComponent2.default, {
          inputId: 'applicationState',
          inputLabel: this.formConfig['additional_data.state'].title,
          inputComponent: _SelectComponent2.default,
          inputComponentField: this.props.fields.application.additional_data.state,
          inputComponentProps: {
            options: this.formConfig['additional_data.state'].options,
            onChangeHook: this.onChangeHook
          }
        }),
        this.props.fields.application.additional_data.additional_applicants_number.value === '5' && this.showAlertMessage('applicants', 'If you have more than 6 applicants, please contact our customer service representative. We would love to assist you with your group application.'),
        (0, _commonFunctions.createAdditionalApplicantRows)(this, dateRestrictions),
        (0, _commonFunctions.showEligibilityBox)(this),
        _react2.default.createElement(_LabelledInputComponent2.default, {
          hasExpandableHint: true,
          expandableHintId: 'policyTypeHint',
          expandableHintContent: this.formConfig['additional_data.policy_type'].hint,
          inputId: 'policyType',
          inputLabel: this.formConfig['additional_data.policy_type'].title,
          inputComponent: _SelectComponent2.default,
          inputComponentField: this.props.fields.application.additional_data.policy_type,
          inputComponentProps: {
            options: this.formConfig['additional_data.policy_type'].options,
            onChangeHook: this.onChangeHook
          }
        }),
        (0, _commonFunctions.effectiveDateField)(this, dateRestrictions),
        _react2.default.createElement(_LabelledInputComponent2.default, {
          inputId: 'returnDate',
          inputLabel: this.formConfig.expiry_date.title,
          inputComponent: _DatePickerComponent2.default,
          inputComponentField: this.props.fields.application.expiry_date,
          inputComponentProps: {
            placeholderText: (0, _translate.t)('Please select a date...'),
            showYearDropdown: true,
            showMonthDropdown: true,
            onChangeHook: function onChangeHook() {
              (0, _commonFunctions.changeExpiryAndCoverageLength)(_this11, 'expiry');_this11.onChangeHook();
            },
            minDate: dateRestrictions.application.expiry_date.min,
            maxDate: dateRestrictions.application.expiry_date.max,
            defaultDate: this.isMultiTrip() ? dateRestrictions.application.default_expiry_date : null,
            disabled: this.isMultiTrip()
          }
        }),
        (0, _commonFunctions.showCoverageLength)(this),
        _react2.default.createElement(_LabelledInputComponent2.default, {
          hasExpandableHint: true,
          expandableHintId: 'destinationCountryHint',
          expandableHintContent: this.formConfig['additional_data.destination'].hint,
          inputId: 'destinationCountry',
          inputLabel: this.formConfig['additional_data.destination'].title,
          inputComponent: _SelectComponent2.default,
          inputComponentField: this.props.fields.application.additional_data.destination,
          inputComponentProps: {
            options: this.isMultiTrip() ? [{ value: 'CA', text: 'Canada' }, { value: 'WW', text: 'Worldwide' }] : (0, _commonFunctions.filterList)(this.formConfig['additional_data.destination'], this.props.removeDestinations),
            onChangeHook: function onChangeHook() {
              (0, _commonFunctions.forcePeCoverage)(_this11);_this11.onChangeHook();
            }
          }
        }),
        this.props.fields.application.additional_data.policy_type.value === 'single trip' && !(this.props.fields.application.additional_data.destination.value === 'US' || this.props.fields.application.additional_data.destination.value === 'CA') ? _react2.default.createElement(_LabelledInputComponent2.default, {
          inputId: 'travellingThroughTheUs',
          inputLabel: this.formConfig['additional_data.travelling_through_the_us'].title,
          inputComponent: _RadioGroupComponent2.default,
          inputComponentField: this.props.fields.application.additional_data.travelling_through_the_us,
          inputComponentProps: {
            options: this.formConfig['additional_data.travelling_through_the_us'].options,
            onChangeHook: this.onChangeHook
          }
        }) : null,
        this.props.fields.application.additional_data.policy_type.value === 'multi-trip annual' ? _react2.default.createElement(_LabelledInputComponent2.default, {
          inputId: 'number_of_days_per_trip',
          inputLabel: this.formConfig['additional_data.number_of_days_per_trip'].title,
          inputComponent: _SelectComponent2.default,
          inputComponentField: this.props.fields.application.additional_data.number_of_days_per_trip,
          inputComponentProps: {
            options: this.props.fields.application.additional_data.destination.value === 'CA' ? this.formConfig['additional_data.number_of_days_per_trip'].ca_options : this.formConfig['additional_data.number_of_days_per_trip'].options,
            placeholder: (0, _translate.t)('Please select...'),
            onChangeHook: function onChangeHook() {
              _this11.onChangeHook();
            }
          }
        }) : null,
        _react2.default.createElement(_LabelledInputComponent2.default, {
          hasExpandableHint: true,
          expandableHintId: 'deductibleHint',
          expandableHintTitle: this.formConfig['additional_data.deductible'].title,
          expandableHintContent: this.formConfig['additional_data.deductible'].hint,
          inputId: 'deductible',
          inputLabel: this.formConfig['additional_data.deductible'].title,
          inputComponent: _SelectComponent2.default,
          inputComponentField: this.props.fields.application.additional_data.deductible,
          inputComponentProps: {
            options: this.formConfig['additional_data.deductible'].options,
            placeholder: (0, _translate.t)('Please select...'),
            onChangeHook: function onChangeHook() {
              _this11.onChangeHook();
            }
          }
        }),
        this.props.formConfig.brand === 'tugo' && _react2.default.createElement(_LabelledInputComponent2.default, {
          inputId: 'homeProvince',
          inputLabel: this.formConfig['additional_data.home_province'].title,
          inputComponent: _RadioGroupComponent2.default,
          inputComponentField: this.props.fields.application.additional_data.home_province,
          inputComponentProps: {
            options: this.formConfig['additional_data.home_province'].options,
            onChangeHook: function onChangeHook() {
              _this11.onChangeHook();
            }
          }
        }),
        this.shouldShowMQModal() && !this.props.hideMQ && this.props.fields.application.additional_data.destination.value !== 'CA' ? this.showAlertMessage('medical_declaration', 'A Medical Declaration must be completed if you are 60 years of age or older as of the effective date of coverage', 'Open Medical Questionnaire', this.showMQModal.bind(this)) : null,
        this.props.fields.application.additional_data.home_province.value === 'no' && this.props.fields.application.additional_data.home_province.value === 'no' && this.showAlertMessage('error', 'Sorry we’re unable to issue coverage at this time. Coverage may still be available, please contact MSH Customer Service(1-800-360-3234, 416-730-8488, helpline@americas.msh-intl.com) to discuss your health and claims status to see if other coverage options are available to you.'),
        this.props.hasSportsCoverage && this.showSportsButton() && !this.showApplicantSports() ? _react2.default.createElement(
          'div',
          { className: 'div-center form-group' },
          _react2.default.createElement(
            _reactBootstrap.Button,
            {
              bsStyle: 'primary',
              className: 'ingle-form-submit-button button',
              onClick: this.showSportsModal.bind(this)
            },
            (0, _translate.t)('Add Sports and Activities Optional Coverage')
          )
        ) : null,
        this.state.showMQModal && _react2.default.createElement(_TugoMedicalQuestionnaire2.default, {
          show: this.state.showMQModal,
          applicantsWithMQ: this.getApplicantsWithMQ(),
          onClose: function onClose() {
            return _this11.setState({ showMQModal: false });
          },
          updateProp: this.updateProp.bind(this),
          formValues: this.props.values,
          onChangeHook: this.onChangeHook.bind(this)
        }),
        this.showSportsDetailsAndCoverages(),
        this.state.showSportsModal && _react2.default.createElement(
          _reactBootstrap.Modal,
          { show: this.state.showSportsModal, bsSize: 'md', onHide: function onHide() {
              return _this11.setState({ showSportsModal: false });
            } },
          _react2.default.createElement(
            _reactBootstrap.Modal.Header,
            null,
            _react2.default.createElement(
              _reactBootstrap.Modal.Title,
              null,
              (0, _translate.t)('Sports & Activities Coverage')
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Body,
            null,
            _react2.default.createElement(
              'div',
              { className: 'info-box info-section' },
              _react2.default.createElement(
                'p',
                null,
                (0, _translate.t)('If a sport or activity is not listed in the Sports & Activities Coverage and is not listed as an exclusion, coverage is already available under the Emergency Medical Insurance plan without the purchase of this optional coverage.')
              ),
              _react2.default.createElement(
                'p',
                null,
                (0, _translate.t)('If you do plan to participate, train, or practice for any of the sports or activities listed below and you want to be covered for them, simply add all the ones that you need. The sports or activities must be listed on your policy declaration for coverage to apply. You will only be charged for the sport or activity with the highest premium charge.')
              ),
              _react2.default.createElement(
                'p',
                null,
                (0, _translate.t)('See the View Details section for more information on the sports and activities that are excluded, or the ones available in the Sports & Activities Coverage.')
              ),
              _react2.default.createElement(
                'p',
                null,
                (0, _translate.t)('Please take note:'),
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    (0, _translate.t)('For any of the sports or activities listed below, if you are coaching and officiating as a referee or sports official, the Sports & Activities Optional Coverage is not required for coverage to apply.')
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    (0, _translate.t)('For football (American or Canadian), ice hockey or rugby, you only need to declare these sports, if you are 21 years or over at the time of application.')
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'info-box excluded-section' },
              _react2.default.createElement(
                'p',
                null,
                (0, _translate.t)('Excluded Activities')
              ),
              _react2.default.createElement(
                'p',
                null,
                (0, _translate.t)('Your participating, training, or practicing in any areas that have been closed off to public access and/or can typically only be accessed by crossing a fenced, gated or roped-off area that has been marked as off limits according to recommendations of safety authorities in the area for the following activities:')
              ),
              _react2.default.createElement(
                'ul',
                null,
                this.state.excludedActivitiesList1.map(function (activity, index) {
                  return _react2.default.createElement(
                    'li',
                    { key: index },
                    (0, _translate.t)(activity)
                  );
                })
              ),
              _react2.default.createElement(
                'p',
                null,
                (0, _translate.t)('Your participating in, training, or practicing for any of the following sports or activities:')
              ),
              _react2.default.createElement(
                'ul',
                null,
                this.state.excludedActivitiesList2.map(function (activity, index) {
                  return _react2.default.createElement(
                    'li',
                    { key: index },
                    (0, _translate.t)(activity)
                  );
                })
              )
            ),
            this.state.showSportsDropdown && _react2.default.createElement(
              'div',
              { style: { marginBottom: '15px' } },
              _react2.default.createElement(
                'select',
                {
                  className: 'ingle-form-select form-control',
                  value: this.state.selectedSport || '',
                  onChange: function onChange(event) {
                    return _this11.updateSelectedSports(event.target.value);
                  }
                },
                _react2.default.createElement(
                  'option',
                  { value: '', disabled: true },
                  (0, _translate.t)('Select a Sport or Activity'),
                  '...'
                ),
                this.state.sportOptions.filter(function (opt) {
                  return !_this11.state.selectedSports.includes(opt.value);
                }).map(function (item, i) {
                  return _react2.default.createElement(
                    'option',
                    { key: i, value: item.value },
                    (0, _translate.t)(item.text)
                  );
                })
              )
            ),
            _react2.default.createElement(
              _reactBootstrap.Grid,
              { className: 'sports-questions', fluid: true },
              this.getSportQuestions().map(function (question, qIndex) {
                return _react2.default.createElement(
                  _reactBootstrap.Panel,
                  { key: question.id, header: _this11.getSportText(question.key.split('.').pop()) },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'p',
                      null,
                      question.text
                    ),
                    _this11.props.fields.applicant.length > 1 && _react2.default.createElement(
                      'div',
                      null,
                      function () {
                        var sportKey = question.key.split('.').pop();

                        return _react2.default.createElement(
                          'div',
                          { className: 'row purchase-message-box' },
                          _react2.default.createElement(
                            'span',
                            { className: 'col-xs-8' },
                            (0, _translate.t)('All travelers')
                          ),
                          _react2.default.createElement('input', {
                            type: 'checkbox',
                            id: 'sportsCoverage_' + question.key + '_all',
                            checked: _this11.isAllTravelersChecked(sportKey),
                            onChange: function onChange(event) {
                              return _this11.toggleAllTravelers(sportKey, event.target.checked);
                            }
                          })
                        );
                      }()
                    ),
                    _react2.default.createElement(
                      'div',
                      null,
                      _this11.props.fields.applicant.map(function (applicant, aIndex) {
                        return _react2.default.createElement(
                          'div',
                          { className: 'row purchase-message-box' },
                          _react2.default.createElement(
                            _reactBootstrap.Col,
                            { xs: 8 },
                            applicant.first_name.value,
                            ' ',
                            applicant.last_name.value
                          ),
                          _react2.default.createElement(
                            _reactBootstrap.Col,
                            { className: 'vertical-align' },
                            _react2.default.createElement(_CheckboxComponent2.default, {
                              inputId: 'sportsCoverage_' + question.key + '_' + aIndex,
                              htmlLabel: '',
                              field: applicant.additional_data.sports_coverage[question.key.split('.').pop()],
                              onChangeHook: function onChangeHook() {
                                _this11.updateAllTravelersChecked(question, aIndex);
                              }
                            })
                          )
                        );
                      })
                    )
                  )
                );
              })
            ),
            this.state.selectedSports.length > 0 && _react2.default.createElement(
              'button',
              { className: 'btn btn-primary button', onClick: function onClick() {
                  return _this11.setState({ showSportsDropdown: true });
                } },
              (0, _translate.t)('Add Another Sport or Activity')
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Footer,
            null,
            _react2.default.createElement(
              _reactBootstrap.Button,
              { className: 'btn btn-primary button margin-left', onClick: this.handleSave.bind(this) },
              (0, _translate.t)('Save & Close')
            )
          )
        ),
        this.renderSportsSummary(),
        (0, _commonFunctions.showSaveQuoteComponent)(this, _application2.default)
      );
    }
  }]);

  return GetQuoteComponent;
}(_react2.default.Component);

GetQuoteComponent.propTypes = _extends({}, _reduxForm.propTypes, {
  params: _react2.default.PropTypes.object,
  auth: _react2.default.PropTypes.object,
  application: _react2.default.PropTypes.object,
  formConfig: _react2.default.PropTypes.object,
  savedQuote: _react2.default.PropTypes.object,
  trackingCode: _react2.default.PropTypes.string
});


var mapStateToProps = function mapStateToProps(state) {
  return {
    auth: state.api.authorization,
    application: state.application,
    formConfig: state.formConfig.config,
    savedQuote: state.savedQuote.data
  };
};

exports.default = (0, _reduxForm.reduxForm)({
  form: 'genericis',
  fields: fields,
  destroyOnUnmount: false,
  touchOnBlur: false,
  validate: _Quote2.default
}, mapStateToProps)(GetQuoteComponent);


//////////////////
// WEBPACK FOOTER
// ./src/v2/containers/tugo/GetQuoteContainer.jsx
// module id = 1718
// module chunks = 0